import React from 'react';
import { ButtonBase } from '@mui/material';
import { UserAvatar, Popper, Typography, Icon, icons } from 'cdh-data-portal-theme';
import { useUserMenu } from './UserMenu.logic';
import { useStyles } from './UserMenu.style';
import { localText } from './UserMenu.static';

export const UserMenu: React.FC = () => {
    const { currentUser, anchorEl, isMenuOpen, handleMenuOpen, handleMenuClose } = useUserMenu();
    const { classes } = useStyles();

    if (!currentUser) {
        return null;
    }

    return (
    <>
        <UserAvatar
            user={currentUser}
            onClick={handleMenuOpen}
            aria-label={localText.MenuAriaLabel}
        />
        <Popper
            arrow
            disablePortal
            open={isMenuOpen}
            anchorEl={anchorEl}
            onClickAway={handleMenuClose}
            placement="bottom-end"
            secondaryOffset={20}
            offset={5}
        >
            <div className={classes.root}>
                <div className={classes.userInfo}>
                    <UserAvatar user={currentUser} size="medium" />
                    {currentUser.fullName && (
                        <Typography variant="headline3" className={classes.displayName}>
                            {currentUser.fullName}
                        </Typography>
                    )}
                    <Typography variant="body" color="textSecondary">
                        {currentUser.id}
                    </Typography>
                    <Typography variant="label1" color="textSecondary">
                        {currentUser.role}
                    </Typography>
                </div>

                <ButtonBase className={ `${classes.signOut} hoverable` } onClick={handleMenuClose}>
                    <Icon iconPath={icons.signOutCompact} color={'currentColor'} />
                    <Typography variant="headline3" hoverVariant={'default'}>{localText.SignOut}</Typography>
                </ButtonBase>
            </div>
        </Popper>
    </>
    );
};
